// extracted by mini-css-extract-plugin
module.exports = {"reqLog":"Req_reqLog__9de4h","reqLogDate":"Req_reqLogDate__1dgAD","reqLogEventName":"Req_reqLogEventName__XwiDi"};